import { MAGNITUDE_EXA, MAGNITUDE_GIGA, MAGNITUDE_PICO } from '../lib/constants';

const prefixes = [
  { name: 'Exa', magnitude: MAGNITUDE_EXA },
  { name: 'Giga', magnitude: MAGNITUDE_GIGA },
  { name: '', magnitude: 0 },
  { name: 'Pico', magnitude: MAGNITUDE_PICO },
];

const getNearestPrefix = (exponent) =>
  prefixes.reduce((p, n) =>
    Math.abs(n.magnitude - exponent) < Math.abs(p.magnitude - exponent) ? n : p,
  );

const getLowerBoundPrefix = (exponent) =>
  prefixes.find((p) => p.magnitude <= exponent) || prefixes[prefixes.length - 1];

export default (value) => {
  const { name, magnitude } = (value.e < 0 ? getNearestPrefix : getLowerBoundPrefix)(value.e);
  const v = value
    .shiftedBy(-magnitude)
    .precision(9 + Math.min(value.e - magnitude, 0))
    .toFixed();
  return `${v}${name ? ' ' : ''}${name}`;
};
